import request from '../utils/request';
import userStorage from '../utils/storage';

export default class Services {
  constructor() {
    this.requestHeader = {
      'Content-Type': 'application/json'
    };
  }

  // get
  get(api, params, headers = this.requestHeader) {
    const newRequestHeader = headers.withAuth
      ? Object.assign(this.requestHeader, headers, { token: userStorage.token })
      : Object.assign(this.requestHeader, headers);
    const newUrl =
      Object.keys(params).length > 0 ? this.getParamsUrl(api, params) : api;

    return request(newUrl, {
      method: 'GET',
      headers: newRequestHeader
    });
  }

  // post
  post(api, params, headers = this.requestHeader) {
    const newRequestHeader = headers.withAuth
      ? Object.assign(this.requestHeader, headers, { token: userStorage.token })
      : Object.assign(this.requestHeader, headers);
    return request(api, {
      method: 'POST',
      headers: newRequestHeader,
      body: JSON.stringify(params)
    });
  }

  // 编辑
  put(api, params, headers = this.requestHeader) {
    const newRequestHeader = headers.withAuth
      ? Object.assign(this.requestHeader, headers, { token: userStorage.token })
      : Object.assign(this.requestHeader, headers);
    return request(api, {
      method: 'PUT',
      headers: newRequestHeader,
      body: JSON.stringify(params)
    });
  }

  // 删除
  delete(api, headers = this.requestHeader) {
    const newRequestHeader = headers.withAuth
      ? Object.assign(this.requestHeader, headers, { token: userStorage.token })
      : Object.assign(this.requestHeader, headers);
    return request(api, {
      method: 'DELETE',
      headers: newRequestHeader
    });
  }

  // 处理get 参数
  getParamsUrl(url, params) {
    if (Object.keys(params).length !== 0) {
      let str = '';
      for (const key in params) {
        str =
          str !== '' ? `${str}&${key}=${params[key]}` : `${key}=${params[key]}`;
      }
      return `${url}?${str}`;
    } else {
      return url;
    }
  }
}
